// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-saying-hello-mdx": () => import("./../../../src/pages/saying/hello.mdx" /* webpackChunkName: "component---src-pages-saying-hello-mdx" */),
  "component---src-pages-talking-about-himself-mdx": () => import("./../../../src/pages/talking/about/himself.mdx" /* webpackChunkName: "component---src-pages-talking-about-himself-mdx" */),
  "component---src-templates-blog-post-js": () => import("./../../../src/templates/blog-post.js" /* webpackChunkName: "component---src-templates-blog-post-js" */)
}

